import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminlogistic',
  templateUrl: './adminlogistic.component.html',
  styleUrls: ['./adminlogistic.component.css']
})
export class AdminlogisticComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
